import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ModalDialogComponent } from 'src/app/components/modals/modal-dialog/modal-dialog.component';
import { AuthenticationService } from 'src/app/components/pages/authentication/authentication/authentication.service';
import { MeasurementResponse, ProductResponse } from 'src/app/models/product.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { BTNDetail, ScaleNote, ScaleNoteDetailRequest } from 'src/app/models/scale-note';
import { VendorResponse } from 'src/app/models/vendor.model';
import { ProductService } from 'src/app/services/product.service';
import { ScaleNoteService } from 'src/app/services/scale-note.service';
import { ScaleService } from 'src/app/services/scale.service';
import { VendorService } from 'src/app/services/vendor.service';

interface ScaleItem {
  name: string;
  id: any;
}

@Component({
  selector: 'app-create-scale-note',
  templateUrl: './create-scale-note.component.html',
  styleUrls: ['./create-scale-note.component.scss']
})
export class CreateScaleNoteComponent implements OnInit {
  @Output() closed = new EventEmitter<boolean>();
  @Input() showModal: boolean = false;
  loading = false;
  loadingScales = false;
  entryNote = {};
  scales: ScaleItem[] = [{ name: 'IND570', id: 'scale1' }, { name: 'IND780', id: 'scale2' }]
  products: ProductResponse[] = [];
  providers: VendorResponse[] = [];
  detailList = [];
  total = 0;
  inputs = {
    provider: {
      value: null,
      verified: false,
      required: true,
      message: 'Campo requerido',
      class: "fa-list",
      color: '',
      tooltip: '',
      data: {
        id: null
      }
    },
    product: {
      value: null,
      verified: false,
      required: false,
      message: 'Campo requerido',
      class: "fa-list",
      color: '',
      tooltip: '',
      data: {
        id: null,
        measurement: null
      }
    }
  };
  scaleNoteData = {
    providerId: null,
    productId: null,
    pilot: '',
    equipmentId: ''
  };
  quantity = 0;
  quantityReceived = 0;
  filterProviders: VendorResponse[] = [];
  filterClients: VendorResponse[] = [];
  filterProducts: ProductResponse[] = [];
  filterScales: any[] = [];
  timeout = null;
  currentClient: VendorResponse;
  currentProvider: VendorResponse;
  scaleDetails: ScaleNoteDetailRequest[] = [];
  measurements: MeasurementResponse = null;
  btnDetails: BTNDetail[] = [
    { id: 1, name: 'Bruto' },
    { id: 2, name: 'Tara' },
    { id: 3, name: 'Neto' }
  ];

  selectedInput!: HTMLInputElement;
  selectedWeightIndex: number | null = null;

  constructor(
    private scaleNoteService: ScaleNoteService,
    private vendorService: VendorService,
    private productService: ProductService,
    private toastService: ToastrService,
    private authService: AuthenticationService,
    private scaleService: ScaleService
  ) { }

  ngOnInit(): void {
    this.getInitialData();
  }

  getInitialData() {
    this.getProviders("");
    this.getProducts("");
  }

  getProviders(clue) {
    this.vendorService.getProvidesByClue(clue).subscribe({
      next: (response: ResponseObject) => {
        this.providers = response.data;
        this.filterProviders = this.providers;
        if (this.filterProviders.length == 0) {
          this.changeInput(this.inputs.provider, null, false, null, 'fa-xmark', null);
        } else if (this.filterProviders.length == 1) {
          this.changeInput(this.inputs.provider, this.filterProviders[0].name, true, null, 'fa-circle-check', this.filterProviders[0]);
        } else {
          if (clue == "") {
            this.changeInput(this.inputs.provider, clue, false, null, 'fa-asterisk', null);
          } else {
            this.changeInput(this.inputs.provider, clue, false, null, 'fa-list', null);
          }
        }
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    });
  }

  getProducts(clue) {
    this.productService.getProducts(clue).subscribe({
      next: (response: ResponseObject) => {
        this.products = response.data

        this.filterProducts = this.products;
        if (this.filterProducts.length == 0) {
          this.changeInput(this.inputs.product, null, false, null, 'fa-xmark', null);
        } else if (this.filterProducts.length == 1) {
          this.changeInput(this.inputs.product, this.filterProducts[0].name, true, null, 'fa-circle-check', this.filterProducts[0]);
        } else {
          this.changeInput(this.inputs.product, clue, false, null, 'fa-list', null);
        }
      },
      error: (error: HttpErrorResponse) => {
        this.changeInput(this.inputs.product, null, false, null, 'fa-xmark', null);
        this.toastService.error(error.error.message);
      }
    });
  }

  changeInput(input, value, verified, required, classIcon, data) {
    input.value = (value) ? value : input.value;
    input.verified = (verified) ? verified : input.verified;
    input.required = (required) ? required : input.required;
    input.class = (classIcon) ? classIcon : input.class;
    input.data = (data) ? data : input.data;
  }

  writeProvider(input) {
    var inputValue = input.target.value;
    clearTimeout(this.timeout);
    this.inputs.provider.class = "typing";
    this.timeout = setTimeout(() => {
      this.getProviders(inputValue);
    }, 500);
  }

  checkProvider(vendor: VendorResponse) {
    this.inputs.provider.class = "fa-circle-check";
    this.inputs.provider.verified = true;
    this.inputs.provider.data = vendor;
    this.inputs.provider.value = vendor.name;
    this.currentProvider = vendor;
  }

  writeProduct(input) {
    var inputValue = input.target.value;
    clearTimeout(this.timeout);
    this.inputs.product.class = "typing";
    this.timeout = setTimeout(() => {
      this.getProducts(inputValue);
    }, 500);
  }

  checkProduct(product: ProductResponse) {
    this.inputs.product.class = "fa-circle-check";
    this.inputs.product.verified = true;
    this.inputs.product.data = product;
    this.inputs.product.value = product.name;

    this.addProduct();
  }

  addProduct() {
    let measureId = this.inputs.product.data.measurement;

    this.productService.getMeasurementsByMeasurementId(measureId).subscribe({
      next: (response: ResponseObject) => {
        this.measurements = response.data;
        this.generateDetails();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    });
  }

  generateDetails() {
    if (this.measurements) {
      this.scaleDetails = [];
      for (let index = 0; index < this.btnDetails.length; index++) {
        const detail: ScaleNoteDetailRequest = {
          weight: 0,
          typeId: this.btnDetails[index].id,
          date: new Date(),
          time: new Date().getTime(),
        }
        this.scaleDetails.push(detail);
      }
    }
  }

  createNote() {
    if (!this.inputs.provider.verified) {
      this.toastService.error("Debe seleccionar un proveedor válido", "Error");
      return;
    }
    if (!this.inputs.product.verified) {
      this.toastService.error("Debe seleccionar un producto", "Error");
      return;
    }
    if (this.scaleDetails.length == 0) {
      this.toastService.error("Debe tener detalles de la nota de báscuala", "Error");
      return;
    }
    if (!this.verifyCreateNoteData()) {
      this.toastService.error("Debe completar todos los campos requeridos", "Error");
      return;
    }

    this.loading = true;
    let request = {
      ...this.scaleNoteData,
      vendorId: this.inputs.provider.data.id,
      productId: this.inputs.product.data.id,
      details: this.scaleDetails.map((d) => {
        return {
          weight: d.weight,
          typeId: d.typeId,
          date: d.date,
          time: (typeof d.time === "string") ? this.timeStringToSeconds(d.time) : d.time,
        }
      }
      )
    };

    this.scaleNoteService.createScaleNote(request).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Nota de entrada creada con éxito", "Éxito");
        this.loading = false;
        this.closed.emit(true);
        this.showModal = false;
      },
      error: (error: HttpErrorResponse) => {
        this.loading = false;
        this.toastService.error(error.error.message, "Error");
      }
    });
  }

  verifyCreateNoteData() {
    if (this.scaleNoteData.equipmentId == '' ||
      this.scaleNoteData.pilot == '') {
      return false;
    }
    return true;
  }

  removeProduct(index: number) {
    this.scaleDetails.splice(index, 1);
  }

  closeModal(modal: ModalDialogComponent) {
    modal.onClose();
    this.closed.emit(false);
  }

  closedCreateNote() {
    this.closed.emit(false);
    this.showModal = false;
  }

  timeStringToSeconds(time: string): number {
    const [hours, minutes, seconds = '0'] = time.split(':');
    return (+hours * 3600) + (+minutes * 60) + (+seconds);
  }

  getScale(scaleId: any) {
    this.scaleService.getScalesValue(scaleId).subscribe({
      next: (response: any) => {
        console.log(response);
      },
      error: (error: any) => {
        console.log(error);
      }
    });
  }

  setValueScale(value: any) {

  }

  setWeightSelected(scaleId: any) {
    this.scaleService.getScalesValue(scaleId).subscribe({
      next: (response: any) => {
        console.log(response);
        if (this.selectedWeightIndex == null) {
          this.toastService.info("No tienes seleccionado un input");
          return;
        }

        this.scaleDetails[this.selectedWeightIndex].weight = response.weight ?? 0;

      },
      error: (error: any) => {
        console.log(error);
        this.toastService.error("Error al obtener valores");
        if (this.selectedWeightIndex != null) {
          // this.scaleDetails[this.selectedWeightIndex].weight = 0.0;
        }
      }
    });
  }

  setValue(value: string) {

    if (this.selectedInput) {
      this.selectedInput.value = value;
    }

  }

}
